import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {RoadKill} from "../RoadKill";
import {TimelineLite} from "gsap";
import {RoadKillGameMode} from "../server/RoadKillGameMode";

export class RoadKillWinCapRunner implements SimplePresentation {
    public shouldRun(): boolean {
        return RoadKill.model.brokeTheBank && RoadKill.model.gameData.nextMode === RoadKillGameMode.NORMAL;
    }

    public start(flowStateController: SimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite();
        tl.add(RoadKill.winCapView.show(flowStateController))
    }
}